import React, {useEffect, useState} from "react";
import authService from "../../services/auth.service";
import {useNetwork} from "../../helpers/useNetwork";
import {useSetRecoilState} from "recoil/dist";
import {tokenInfoState} from "../../states/states";

const withAuth = BaseComponent => (props) => {
    const {uuid, phoneNumber, app_id} = props;
    const [accessToken, setAccessToken] = useState("");
    const [getTokenErr, setGetTokenErr] = useState(null);
    let jwt_decode = require('jwt-decode');
    const isOnline = useNetwork();
    const setTokenInfoState = useSetRecoilState(tokenInfoState);

    useEffect(() => {
        let oldToken = localStorage.getItem("accessToken");
        if (!oldToken) {
            getAuth();
        } else {
            let decodedToken = jwt_decode(oldToken);
            let userInfo = JSON.parse(decodedToken.sub);
            setTokenInfoState(userInfo);
            console.log(userInfo.phone);
            //work-around: check đầu số điện thoại để set ngôn ngữ
            if (userInfo.phone.startsWith('856') || userInfo.phone.startsWith('+856')) {
                let currentLanguage = localStorage.getItem("language")
                if (!currentLanguage || currentLanguage != 'laos') {
                    localStorage.setItem("language", "laos");
                    window.location.reload();
                }
            }
            let currentTime = Math.floor(new Date().getTime() / 1000.0);
            if (userInfo.uuid !== uuid || decodedToken.exp < currentTime) {
                getAuth();
            } else {
                setAccessToken(oldToken);
            }
        }
    }, [accessToken, uuid]);

    let loading = false;
    const getAuth = () => {
        if (loading === false && isOnline) {
            if (uuid) {
                loading = true;
                setGetTokenErr(null);
                updateAccessToken("");
                authService.checkAuthentication(uuid, phoneNumber, app_id)
                    .then(response => {
                        if (response.status !== 200) {
                            setGetTokenErr({"response": response});
                        } else {
                            let data = response.data;
                            console.log(data);
                            loading = false;
                            if (data.accessToken) {
                                updateAccessToken(data.accessToken);
                                let decodedToken = jwt_decode(data.accessToken);
                                console.log(decodedToken);

                                let tokenInfo = JSON.parse(decodedToken.sub);
                                setTokenInfoState(tokenInfo);
                                console.log(tokenInfo.phone);
                                //work-around: check đầu số điện thoại để set ngôn ngữ
                                if (tokenInfo.phone.startsWith('856') || tokenInfo.phone.startsWith('+856')) {
                                    let currentLanguage = localStorage.getItem("language")
                                    if (!currentLanguage || currentLanguage != 'laos') {
                                        localStorage.setItem("language", "laos");
                                        window.location.reload();
                                    }
                                }
                            }
                        }
                    })
                    .catch((error) => {
                        loading = false;
                        setGetTokenErr(error)
                    });
            }
        }
    };

    const updateAccessToken = (accessToken) => {
        setAccessToken(accessToken);
        localStorage.setItem("accessToken", accessToken);
    };

    return (
        <React.Fragment>
            <BaseComponent {...props} accessToken={accessToken} getTokenErr={getTokenErr}/>
        </React.Fragment>
    );
};

export default withAuth;
